// declare var window: any;
import wx from 'jweixin-1.6.0'

export function setShareConfig(signature: string, appId: string, noncestr: string, timestamp: string) {
    wx.config({
        debug: true,
        signature: signature,
        appId: appId,
        nonceStr: noncestr,
        timestamp: timestamp,
        jsApiList: [
            'onMenuShareAppMessage', //1.0 分享到朋友
            'onMenuShareTimeline', //1.0分享到朋友圈
            'updateAppMessageShareData', //1.4 分享到朋友
            'updateTimelineShareData', //1.4分享到朋友圈
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
}

export function setShareReady(title, desc, link, imgUrl) {
    // 微信分享
    wx.ready(function () {
        let shareData = {
            title: title,
            desc: desc,
            link: link,
            imgUrl: imgUrl,
            trigger: function (res) {
                // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                //alert('用户点击发送给朋友');
            },
            success: function (res) {

                //window.location.href = "http://t.cn/RZmX3L7" ;
            },
            cancel: function (res) {
                //alert('已取消');
            },
            fail: function (res) {
                //alert(JSON.stringify(res));
            }
        }
        if (wx.onMenuShareAppMessage) { //微信文档中提到这两个接口即将弃用，故判断
            wx.onMenuShareAppMessage(shareData);//1.0 分享到朋友
            wx.onMenuShareTimeline(shareData);//1.0分享到朋友圈
        } else {
            wx.updateAppMessageShareData(shareData);//1.4 分享到朋友
            wx.updateTimelineShareData(shareData);//1.4分享到朋友圈
        }

    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/setShareInfo.ts